import { render } from "./WorkHistoryView.vue?vue&type=template&id=ca973316&ts=true"
import script from "./WorkHistoryView.vue?vue&type=script&lang=ts"
export * from "./WorkHistoryView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__